import SearchIcon from '@mui/icons-material/Search';
import { Grid, IconButton, InputAdornment, TextField } from '@mui/material';
import React from 'react';

import { debounce, useIsWidthUp } from '../utils';

export const TripListToolbar = (props) => {
    const searchQueryRef = React.useRef(null);
    const isSmallScreen = !useIsWidthUp('sm')

    const handleSearchQueryChange = (ev) => {
        debouncedSearchQueryChangeHandler.cancel();
        doSearch(searchQueryRef.current?.value);
    };

    const debouncedSearchQueryChangeHandler = debounce(handleSearchQueryChange, 300);

    const doSearch = (query) => props.onQueryChange && props.onQueryChange(query);


    return (
            <Grid item xs={12} sm={4} p={isSmallScreen ? 0 : 2} px={isSmallScreen ? 1 : 2} >
                <TextField
                    variant="filled"
                    label="Search"
                    defaultValue={props.query}
                    size="small"
                    onChange={debouncedSearchQueryChangeHandler}
                    inputRef={searchQueryRef}
                    fullWidth
                    InputProps={{
                        endAdornment: (
                            <InputAdornment position="end">
                                <IconButton aria-label="do search" onClick={handleSearchQueryChange}>
                                    <SearchIcon />
                                </IconButton>
                            </InputAdornment>
                        ),
                    }}
                />
            </Grid>
    );
};

export default TripListToolbar;
